import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../../Global/loader.js'
import BootstrapTable from 'react-bootstrap-table-next';
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal';
import { Button, Row, Col } from 'react-bootstrap'
import Create from './CreateTecajnaLista.js'
import GetList from '../../../../API/Provider/GetExchangeRate'
import { withNamespaces } from 'react-i18next';
import deleteExchange from '../../../../API/Provider/DeleteExchangeRate'
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import Edit from './UpdateTecajnaLista'
import { store } from 'react-notifications-component';
import CreateButton from './../../../../Global/CreateButton'
import moment from 'moment'
import { AiFillEdit } from 'react-icons/ai'
import history from '../../../../history.js';

class TecajnaLista extends React.Component {
    constructor(props) {
        super(props)
        
        this.state={
            loading: true,
            create: false,
            showDeleteModal: false,     
            uuidForDelete: "",  
            edit: false,
            customStyles: {
                content : {
                    top                   : '50%',
                    left                  : '50%',
                    right                 : 'auto',
                    bottom                : 'auto',
                    transform             : 'translate(-50%, -50%)',
                    color: 'red'
                }
            }
        }
    }

    componentDidMount = async () => {        
        document.title = this.props.t("Exchange rate") + "-" + this.props.t("List")
        
        //get countries
        let items = await GetList() 

        await this.props.mapState("MAP_EXCHANGE_RATE_LIST", items.data)

        await this.setState({
            loading: false            
        })
    }

    toggleCreate = async () => {
        this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
    }

    backFromEdit(){
        this.setState({
            edit: !this.state.edit
        })
        this.componentDidMount()
    }

    seeDetails = async (data) => {
        await this.props.mapState("MAP_ONE_EXCHANGE_RATE", data)
        await this.setState({
            edit: !this.state.edit
        })
    }

    backFromEdit = async () =>{
        await this.setState({
            edit: !this.state.edit
        })

        this.componentDidMount()
    }

    goBack(){
        history.goBack();
    }

    showDeleteModal = row => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            dataForDelete: row
        });
    };

    confirmDelete = async () => {
        let deleted = await deleteExchange(this.state.dataForDelete)
        if(deleted.data.data.status !== "success"){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })
            await store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t("There was an error deleting Exchange rate, please try again"),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            }) 

            await store.addNotification({
                title: this.props.t('Success!'),
                message: this.props.t("Exchange rate have been deleted"),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.componentDidMount()
        }
    }
   
    render(){  
        const { loading, create, edit } = this.state 
        const { t } = this.props

        const columns =[{
            dataField: 'currency_name',
            text: t('Currency')
        }, {
            dataField: 'currency_short',
            text: t('Alias')
        }, {
            dataField: 'date_of_exchange_rate',
            text: t('Date'),
            formatter: (cellContent, row) => {
                let date = new Date(row.date_of_exchange_rate)
                let momentum = moment(date).format('DD.MM.YYYY')
                return (                
                <div key={row.uuid} >
                    <span>{ momentum }</span>
                </div>
                
                );
            }
        }, {
            dataField: 'exchange_rate',
            text: t('Exchange Rate')
        },  {
            dataField: 'automatic',
            text: t('Automatic'),
            formatter: (cellContent, row) => {          
            return (
                <div key={row.uuid} className={`${row.automatic ? "color-green" : "color-red"}`}>
                    <strong>
                        { row.automatic ?  t("Yes") : t("No") }
                    </strong>
                </div>
            );
            }
        }, {
            dataField: "sakriveno",
            text: '',
            isDummyField: true,
            style: {width: '11.8em'},
            formatter: (cellContent, row) => {          
              return (
                    <div key={row.uuid}>
                        <Button
                            variant="success"
                            className="btnDetalji me-2"
                            onClick={() => this.seeDetails(row)}
                        >
                            <AiFillEdit /> {t("Details")}
                        </Button>

                        <Button
                            variant="danger"
                            className="btnIzbrisi"
                            onClick={() => this.showDeleteModal(row.uuid)}
                        >
                            <RiDeleteBin5Line /> {t("Delete")}
                        </Button>
                        
                    </div>
              );
            }
          } 
    ] 

    return (
        <div>
        {loading ? 
            <Loader />
        :
            <div>
                {create ? 
                    <Create goBack={() => this.backFromCreate()} />
                :
                edit ? 
                    <Edit goBack={() => this.backFromEdit()} />
                :
                <div className="container">
                    <Row className="mb-4">
                        <Col sm={12}>
                            <CreateButton  style={{padding:"20px", }} className="col-6 col-xl-4" toggleCreate={this.toggleCreate}/>
                        </Col>
                    </Row>
                        {this.props.exchangeRateList.length > 0 ?
                            <ToolkitProvider
                                keyField="uuid"
                                data={this.props.exchangeRateList}
                                columns={columns}
                                columnToggle     
                                prikaziSakrij = {this.prikaziSakrij}    
                                bodyStyle={ {wordBreak: 'break-word'} }                         
                            >
                                {(props) => (
                                <div className="table-responsive">
                                    <BootstrapTable {...props.baseProps} hover bodyClasses="table-body" />
                                </div>
                                )}
                            </ToolkitProvider>  
                        :
                        <div className="list-empty-container">
                            <h1>{t(this.props.message)}</h1>
                        </div>    
                    }

                        <Modal
                            isOpen={this.state.showDeleteModal}                
                            onRequestClose={() => this.showDeleteModal("")}
                            style={this.state.customStyles}
                        >
            
                            <h3 className="modal-title">{t('Warning!')}</h3>
                                    
                            <div className="mb-4">
                                <p>
                                    {t('Deleting the Exchange rate will also delete other data related to it.')}       
                                </p>                     
                            </div>

                            <Row>
                                <Col sm={6}>
                                    <Button variant="primary" onClick={() => this.showDeleteModal("")}>{t('Close')}</Button>
                                </Col>
                                <Col sm={6}>
                                    <Button variant="danger" onClick={() => this.confirmDelete()}> {t('Delete')}</Button>
                                </Col>                
                            </Row>
                    
                        </Modal> 
                    </div>
                }
                         
            </div>
        }
        </div>
    )
}
}
const mapStateToProps = state => {
    return {
        exchangeRateList: state.codeBook.exchangeRateList,
        message: state.adminClient.message,
        credentials: state.user.credentials
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(TecajnaLista));